import Vue from "vue"
import {parsePhoneNumber} from "libphonenumber-js"

Vue.filter("trim", (value, length = 50) => {
    try {
        if (value.length > length) return value.substring(0, length) + "..."
    } catch (e) {
    }
    return value
})

Vue.filter("pluralize", (word, amount) => {
    return amount > 1 || amount == 0 ? `${word}s` : word
})

Vue.filter("capitalise", value => {
    if (!value) return ""
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter("currency", (value, decimals = 2, show_commas = true) => {
    // prettier-ignore
    return '$' + parseFloat(parseFloat(value).toFixed(2)).toLocaleString('en-AU', {
        useGrouping: true,
        minimumFractionDigits: 2,
    })
})

// Format phone number with CX prefix for calling
// i.e. 0412345678 => 270412345678 (where 27 is the cx_prefix)
Vue.filter("formatCxPhone", phone => {
    try {
        const {number, nationalNumber} = parsePhoneNumber(phone.toString(), "AU")
        const cx_prefix = Ambition.getGlobal("tenant.cx_prefix")
        return `${cx_prefix}0${nationalNumber}`
    } catch (e) {
        return ""
    }
})
